import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, HostBinding, Input, ViewChild } from '@angular/core';
import { WIZ_PHYSIC_POSITION } from '@wizeoo/akm-core-lib';
import {
  IWizItemRenderer,
  PopUpManager,
  WizLabel,
  WizPopUp,
  WizEventManager
} from '@wizeoo/akm-component-lib';

import { ViewData } from '../../../../model/view.data';
import { AlkEvent } from '../../../../framework/events/alk.event';
import { ALK_EVENT_TYPE } from '../../../../model/enums';
import { PopUtils } from '../../../../framework/components/pop/pop-utils';
import { FreedataTimelineFilterObj } from '../../freedatatimeline/freedata-timeline-filter.obj';
import { FreedataTimelineFilterExtendedPop } from './freedata-timeline-filter-extended.pop';

/**
 * rendu d'un filtre de pivot
 */
@Component({
  selector: 'freedata-timeline-filter-extended-renderer',
  templateUrl: './freedata-timeline-filter-extended.renderer.html',
})
export class FreedataTimelineFilterExtendedRenderer implements AfterViewInit, IWizItemRenderer<null, FreedataTimelineFilterObj> {
  @HostBinding('style.width') elwidth: string = '180px';
  @HostBinding('style.min-width') elminwidth: string = '180px';
  @HostBinding('style.height') elheight: string = '40px';
  @ViewChild('filterNameLbl', { read: WizLabel }) filterNameLbl: WizLabel;
  @ViewChild('filterContentLbl', { read: WizLabel }) filterContentLbl: WizLabel;
  @ViewChild('block') block: ElementRef;

  constructor(public cdref: ChangeDetectorRef, public elementRef: ElementRef) {}

  owner: null;
  private _data: FreedataTimelineFilterObj;
  /**
   * Sets the data that needs to be rendered
   */
  @Input() public set data(value: FreedataTimelineFilterObj) {
    this._data = value;
    this.cdref.markForCheck();
  }

  public get data(): FreedataTimelineFilterObj {
    return this._data;
  }

  ngAfterViewInit() {
    // console.log('filter', this.data);
    this.filterNameLbl.wizLabel = this.data.label;
    this.updateFilter(false);
  }

  private updateFilter(doDispatch: boolean = true): void {
    // console.log(this.data.selectedAsString);
    // TODO détecter le changement. Inutile de filtrer sinon
    // if (this.data.selectedAsString && this.data.selectedAsString.length > 0) {
    //   this.filterContentLbl.wizLabel = this.data.selectedAsLabel;
    //   // this.filterContentLbl.tooltipEnabled = true;
    //   this.filterContentLbl.tooltipText = this.data.selectedAsLabel;
    // } else {
    //   this.filterContentLbl.wizLabel = ' ';
    //   // this.filterContentLbl.tooltipEnabled = false;
    // }

    // this.data.hasFilter = this.data.selectedAsString.length > 0;

    // TODO détecter le changement. Inutile de filtrer sinon
    this.data.hasFilter = this.data.selectedAsString.length > 0 || !!this.data.exp;
    
    if (this.data.hasFilter) {
      this.filterContentLbl.wizLabel = this.data.trueLabel;
      this.filterContentLbl.tooltipText = this.data.trueLabel;
    } else {
      this.filterContentLbl.wizLabel = ' ';
    }


    if (doDispatch) {
      WizEventManager.dispatchEvent(this.elementRef, new AlkEvent(ALK_EVENT_TYPE.INNER_FILTER_UPDATE, this.data));
    }
  }

  /**
   * suppression d'un élément des zones de contenu
   * (va passer dans setFilter)
   */
  public clearFilter(e: any): void {
    this.data.filterDS.clearSelection();
    this.data.exp = null;
    this.updateFilter();
  }

  public showHidePop(): void {
    const filterPop: WizPopUp = new WizPopUp(
      FreedataTimelineFilterExtendedPop,
      false,
      false,
      null,
      '400px',
      '350px',
      [this.data, this.backFromFilterPop.bind(this)]
    );
    const pos: DOMRect = this.block.nativeElement.getBoundingClientRect();

    const bestXY: [number, number] = PopUtils.setPopCoord(pos, filterPop, WIZ_PHYSIC_POSITION.BOTTOM_RIGHT);
    const x: string = bestXY[0] + 'px';
    const y: string = bestXY[1] + 'px';
    const targetPosition: any = { left: x, top: y }; // position physique
    filterPop.customPosition = targetPosition;

    if (PopUpManager.exist(filterPop)) {
      // suppression de l'instance existante
      filterPop.hide();
    }
    // ouverture de la pop. Data[fei, context, WizbaseCollector, PivotField, callback]
    filterPop.show();
  }

  private backFromFilterPop(data: FreedataTimelineFilterObj): void {
    // construction de la sélection (si selectedItems)
    if(data.filterDS.selectedItems?.length > 0) {
      const valArr: string[] = data.filterDS.selectedItems.map(item => item.code);
      data.sel = valArr.join(ViewData.KEY_SEPARATOR);
    } else {
      data.sel = null;
    }
    
    
    data.applyFilterSelection(); // refresh sur les selectedItem du filtre
    this.updateFilter();
  }
}
